<template>
  <BModal
    id="modal-session-expired"
    ref="modal-session-expired"
    no-close-on-esc="no-close-on-esc"
    no-close-on-backdrop="no-close-on-backdrop"
    hide-header-close="hide-header-close"
  >
    <template slot="modal-title">
      {{ __('Sessão Expirada') }}
    </template>
    <template slot="default">
      {{ __('Sua sessão expirou. Faça login novamente para continuar') }}.
    </template>
    <template slot="modal-footer">
      <a href="/logout">
        <button
          class="btn btn-default"
          type="button"
        ><i class="fa fa-btn fa-sign-in" /> Login</button></a>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },
};
</script>
